import {isProduction} from '@/utils/environment';

const isProd = isProduction;

export const AllowedCountryCodesSignIn = isProd
  ? ['us', 'ar', 'co', 'pe', 'br', 'mx', 'in']
  : null;

export const AllowedCountryCodesTeens = AllowedCountryCodesSignIn;

export const AllowedCountryCodesSignUp = isProd ? ['us'] : null;

export const AdditionalPhoneNumbersAllowed = !isProd
  ? ['+1112223333', '+1112224444', '+1112225555', '+16021158886']
  : null;
